import { render, staticRenderFns } from "./UserClientNumberEditForm.vue?vue&type=template&id=2bcb3900"
import script from "./UserClientNumberEditForm.vue?vue&type=script&lang=js"
export * from "./UserClientNumberEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports